import React from 'react';
import { benefits } from '../data/content';
import { crewPhoto } from '../data/gallery';
import { ServiceAreaMap } from './ServiceAreaMap';
export function DifferenceSection() {
  return <section id="why-dany" className="scroll-mt-20 bg-cream py-20 md:py-28" data-id="element-45" data-mp="1p1guhrtx3p44">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-46" data-mp="1ozdtydv52dl5">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-47" data-mp="1k1vtlbv6t6or">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-48" data-mp="1y1wwsxyxcq7e">
            <h2 className="font-display text-3xl font-bold leading-tight text-forest md:text-5xl" data-id="element-49" data-mp="1y02776cpk9wz">
              What Makes Dany Different
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-muted" data-id="element-50" data-mp="27qwume1oxfk0">
              Family-owned and Dallas-based. No chains, no rotating crews.
            </p>
            <figure className="mt-8" data-id="element-51" data-mp="2hq5vzryvxwge">
              <img src={crewPhoto.src} alt={crewPhoto.alt} className="aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-52" data-mp="2hr7ay7j0v33e" />
              <figcaption className="mt-2 text-sm text-ink-muted" data-id="element-53" data-mp="2fsfiewjldld0">Our crew setting a limestone border.</figcaption>
            </figure>
          </div>

          <ul className="divide-y divide-stone-line border-y border-stone-line" data-id="element-54" data-mp="2ksuulks50mte">
            {benefits.map(({
            title,
            body,
            icon: Icon
          }) => <li key={title} className="flex gap-5 py-7" data-id="element-55" data-mp="2tt017spibh6i">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-forest text-white" data-id="element-56" data-mp="2yr1koequhiii">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-57" data-mp="33okxda7w9n8c" />
                </span>
                <div data-id="element-58" data-mp="38g2wdsqcxdqo">
                  <h3 className="text-xl font-semibold text-forest" data-id="element-59" data-mp="38hmdflju7sti">{title}</h3>
                  <p className="mt-2 leading-relaxed text-ink-muted" data-id="element-60" data-mp="3ci6e2z3mdeke">{body}</p>
                </div>
              </li>)}
          </ul>
        </div>

        <ServiceAreaMap data-id="element-61" data-mp="3hewrtfryby2n" />
      </div>
    </section>;
}